import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../../utils/enum";
import axiosInstance from "./axiosInstance";

type DataListProps = {
    배송완료: number | null;
    배송중: number | null;
    오더접수: number | null;
    접수취소: number | null;
    픽업예약: number | null;
    픽업완료: number | null;
};

export interface TodayCountResponseData {
    data: DataListProps[];
    messgae: string;
    statusCode: number;
}

export const useGetMapTodayCount = (): UseQueryResult<TodayCountResponseData, Error> => {
    let url = enum_api_uri.TODAY_COUNT;
    return useQuery({
        queryKey: ["useGetMapTodayCount"],
        queryFn: async () => {
            const response = await axiosInstance.get(url);
            return response.data;
        },
    });
};
